/* import __COLOCATED_TEMPLATE__ from './end-user-auth-sidedrawer.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  isOpen: boolean;
  onClose: () => void;
  closeOnSave: () => void;
}

const EndUserAuthSidedrawer = templateOnlyComponent<Args>();
export default EndUserAuthSidedrawer;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::EndUserAuthSidedrawer': typeof EndUserAuthSidedrawer;
    'standalone/zendesk/deploy/common/end-user-auth-sidedrawer': typeof EndUserAuthSidedrawer;
  }
}
